import { SelectLang } from '@/components/RightContent';
import { SettingDrawer, type Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { App, Modal } from 'antd';
import { useState } from 'react';
import defaultSettings from '../config/defaultSettings';
import { AvatarDropdown, AvatarName } from './components/RightContent/AvatarDropdown';
import { errorConfig } from './requestErrorConfig';
import { postUserCurrent } from './services/operation-api/user';
import AntdWrapApp, { message } from './utils/globalMessage';
import { GET_TOKEN, REMOVE_TOKEN, REMOVE_REFRESHTOKEN } from './utils/token';
import { Item } from 'rc-menu';
import { cloneDeep } from 'lodash';
const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/login';
const mobileRoutes = [
  '/welcome',
  '/verification',
  '/mobileActivity',
  '/mobileServiceReservation',
  '/shopInfo',
  '/mobileOrder',
  '/voice',
  '/accountInfo',
  '/mobileIntentionOrder',
  '/mobilePayment',
  '/writeoffList',
  '/mCt',
  '/dataHomePage/dataPage',
  '/mobileFiredInfo'
];
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */

function readNodes(nodes: API.MenuVo[], arr: string[] = []) {
  if (!nodes) {
    return arr;
  }
  nodes.map((item) => {
    arr.push(item.path as string);
    if (item.children && item.children.length) {
      readNodes(item.children, arr);
    }
  });
  return arr;
}

function filterRoute(asyncRoute: any, routes: any) {
  return asyncRoute.filter((item: any) => {
    if (routes.includes(item.path)) {
      if (item.children && item.children.length > 0) {
        item.children = filterRoute(item.children, routes);
      }
      return true;
    }
  });
}

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  loading?: boolean;
  currentUser?: API.OperationerUserVo;
  // currentShop?: API.ShopVo[];
  pathCodes?: any[];
  fetchUserInfo?: () => Promise<API.OperationerUserVo | undefined>;
  fetchUserShop?: () => Promise<API.ShopVo[] | undefined>;
  authorizedShops?: API.ShopVo[];
  myShops?: API.ShopVo[];
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await postUserCurrent();
      return msg.data;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };



  // 如果不是登录页面，执行
  const { location } = history;
  //上线注释
  if (location.pathname !== loginPath) {
    const currentUser = await fetchUserInfo();
    // const currentShop = await fetchUserShop();
    const authorizedShops = currentUser?.authorizedShops || [];
    const myShops = currentUser?.shops || [];

    return {
      currentUser,
      // currentShop,
      authorizedShops,
      myShops,
      fetchUserInfo,
      // fetchUserShop,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,

    // fetchUserShop,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

//用App包裹AntdWrapApp组件，全局使用useApp中的message
export function rootContainer(container: React.ReactElement) {
  return (
    <App>
      <AntdWrapApp />
      {container}
    </App>
  );
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>();
  return {
    collapsed: isCollapsed,
    onCollapse: (collapsed: any) => {
      setIsCollapsed(collapsed);
    },
    //问号和选择语言
    // actionsRender: () => [<SelectLang key="SelectLang" />],
    //头像展示
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: initialState?.currentUser?.nickname,
      render: (_, avatarChildren: any) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    //网页水印
    waterMarkProps: {
      content: initialState?.currentUser?.nickname
      ,
    },
    //展示footer
    // footerRender: () => <Footer />,
    //上线注释
    //路由切换，未登录重定向到登录页
    onPageChange: async () => {
      const { location } = history;
      // 如果没有登录，其它页重定向到 login
      if (!GET_TOKEN() && !initialState?.currentUser && location.pathname !== loginPath) {
        message.error('请先登录！');
        history.push(loginPath);
      } else if (GET_TOKEN() && location.pathname === loginPath) {
        //如果登录了,登录页重定向到其它页
        const urlParams = new URL(window.location.href).searchParams;
        history.push(urlParams.get('redirect') || '/');
      }
    },

    layoutBgImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],

    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children: any) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState: any) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
  // baseURL: isDev ? '' : '/192/merchantlp',
};
